import { Link } from "react-router-dom";

const LetsConnect = () => {
  return (
    <section className="py-24 bg-[#fff9e6]">
      <div className="max-w-7xl mx-auto px-6">
        
        {/* Main Card */}
        <div className="relative bg-[#e8c75a] rounded-[2.5rem] px-10 py-16 overflow-hidden flex flex-col md:flex-row items-center justify-between">
          
          {/* Left Decoration */}
          <img
            src="https://cdn-icons-png.flaticon.com/512/1046/1046754.png"
            alt="cupcake"
            className="absolute left-6 bottom-6 w-24 opacity-80 hidden md:block"
          />

          {/* Text Content */}
          <div className="max-w-xl text-center md:text-left">
            <h2 className="text-4xl md:text-5xl font-serif text-[#c03b6c] mb-6">
              Let’s Connect
            </h2>

            <p className="text-lg text-[#3f3f00] mb-8">
              Whether you're interested in collaborating or simply talking
              about food, I'd love to connect with you!
            </p>

            <Link
              to="/contact"
              className="inline-block bg-[#6b6f00] text-white px-8 py-3 rounded-full text-lg font-medium hover:bg-[#5a5d00] transition"
            >
              contact me
            </Link>
          </div>

          {/* Right Illustration */}
          <img
            src="https://cdn-icons-png.flaticon.com/512/616/616408.png"
            alt="dog"
            className="w-64 md:w-80 mt-10 md:mt-0"
          />
        </div>

      </div>
    </section>
  );
};

export default LetsConnect;
